import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/index";
import Layout from "./Layout";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Elements } from "@stripe/react-stripe-js";
import {
  Appearance,
  loadStripe,
  StripeElementsOptions,
} from "@stripe/stripe-js";
import { AppProvider } from "./Context/AppContext";
import SessionHandler from "./SeesionHandler/SessionHandler";
import SessionExpiredModal from "./components/Models/SessionExpiryModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { InviteProvider } from "./Context/InviteContext";
import { GlobalInviteListener } from "./components/Messages/GlobalInviteListener";
import { ModalProvider } from "./Context/ModalContext";
import GlobalModal from "./components/common/GlobalModal";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!);

const App: React.FC = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: false,
      },
    },
  });

  const appearance: Appearance = {
    theme: "stripe",
  };

  const options: StripeElementsOptions = {
    appearance,
  };
  return (
    <I18nextProvider i18n={i18n}>
      <Router>
      <QueryClientProvider client={queryClient}>
        <Elements options={options} stripe={stripePromise}>
          <AppProvider>
            <ModalProvider>
              <GlobalModal />
              <SessionHandler />
              <ToastContainer position="top-right" autoClose={3000} />
              <InviteProvider>
                <GlobalInviteListener />
                <Layout />
              </InviteProvider>
              <SessionExpiredModal />
            </ModalProvider>
          </AppProvider>
        </Elements>
      </QueryClientProvider>
      </Router>
    </I18nextProvider>
  );
};

export default App;
